// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"loginHeader__wrapper","header-text":"loginHeader__header-text"};